<h1 class="h5">Payments</h1>
<!-- Filters -->
<div class="card card-body border-0 shadow mb-3">
  <button class="btn btn-primary w-100 fw-bold d-block d-lg-none mb-2" type="button" data-bs-toggle="collapse"
          data-bs-target="#filters" aria-expanded="false" aria-controls="filters"><i class="bi bi-funnel"></i> Filters
  </button>
  <form [formGroup]="filters" (ngSubmit)="fetchAll()" id="filters" class="collapse filters">
    <div class="row mb-3 g-2 align-items-end">
      <div class="col-lg-8">
        <app-date-range-selector (dateChanged)="updateRange($event)"
                                 (dateRangeInvalidChange)="dateRangeInvalid = $event"
                                 [shortTimezone]="true"
                                 [showTimezone]="false"></app-date-range-selector>
      </div>

      <div class="col-auto d-inline-flex">
        <app-dropdown-select placeholder="Status" [multiple]="true" formControlName="status">
          <app-dropdown-select-option *ngFor="let invoiceStatus of invoiceStatusList" [value]="invoiceStatus">
            {{ 'invoiceStatus.' + invoiceStatus | translate }}
          </app-dropdown-select-option>
        </app-dropdown-select>
      </div>

      <div class="col-auto">
        <select formControlName="deferred" class="form-select form-select-sm">
          <option value="">Deferred</option>
          <option [value]="1">Yes</option>
          <option [value]="0">No</option>
        </select>
      </div>

      <div class="col text-end">
        <button type="submit" class="btn btn-primary btn-sm fw-bold" [disabled]="dateRangeInvalid">Filter</button>
      </div>
    </div>
  </form>

  <div class="table-responsive">
    <table class="table table-hover table-striped">
      <thead class="table-light">
      <tr>
        <th>Period</th>
        <th>Invoice Date</th>
        <th>Invoice Number</th>
        <th>Amount</th>
        <th>Status</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let billingRequest of billingRequests">
        <td>{{ billingRequest.startingAt | date: 'dd/MM/yyyy' }}</td>
        <td>{{ billingRequest.startingAt | date: 'dd/MM/yyyy' }} - {{ billingRequest.endingAt | date: 'dd/MM/yyyy' }}</td>
        <td>Invoice #{{ billingRequest.invoice }}</td>
        <td>{{ billingRequest.totalAmount | currency: 2:billingRequest.paymentCurrency?.isoCode }}</td>
        <td>
          <div class="d-flex align-items-center">
            <span class="me-2 text-muted small">{{ billingRequest.updatedAt | date: 'dd/MM/yyyy' }}</span>
            <span *ngIf="billingRequest.deferred" class="badge bg-secondary text-dark">Deferred</span>
            <span *ngIf="!billingRequest.deferred && billingRequest.invoice" [ngClass]="billingRequest.invoice.getStatusClass()" class="badge">
              {{ 'invoiceStatus.' + billingRequest.invoice.status | translate }}
            </span>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <app-paginator (pageChange)="fetchAll()" [paginator]="paginator"></app-paginator>
</div>
